module.exports = __webpack_public_path__ + "img/equipment-gray.7fe6d022.svg";